const form = require('./form.ejs');
const html = require('./html.ejs');

export default { form, html };
